import { SlotGame } from "../../net/proto/proto_slot_game";
import { SlotData, SlotGrid, ILineData, GridPoint, LineType, ILineResult, ILineBox } from "../table/slot_data";
import { SlotLineHolder, SlotLine } from "../line_holder_slot";
import LoaclStorage from "../../../../manager/local_storage";
import Utility from "../../../../utility/utility";
import SlotTableSound from "./slot_table_sound";
import GameUtil from "../../../../utility/game_util";
import { SpriteHolderSlot } from "../sprite_holder_slot";
const { ccclass, property } = cc._decorator;
@ccclass
export default class SlotTableLine extends cc.Component {
    @property(cc.Node)
    normalNodeEx: cc.Node = null
    @property(cc.Node)
    lineEx: cc.Node = null
    @property(cc.Node)
    winEx: cc.Node = null
    @property(cc.Node)
    pointEx: cc.Node = null
    @property(cc.Node)
    baseLineParent: cc.Node = null
    @property(cc.Node)
    singleLineParent: cc.Node = null
    @property(cc.Node)
    singleLineLightParent: cc.Node = null
    @property(cc.Node)
    boxLineParent: cc.Node = null
    @property(SlotLineHolder)
    lineHolder: SlotLineHolder = null
    @property(cc.EditBox)
    testEditor: cc.EditBox = null
    @property(cc.Node)
    testNode: cc.Node = null
    @property(SpriteHolderSlot)
    spriteHoder: SpriteHolderSlot = null
    slotRoomData: SlotData

    initLine(data: SlotData) {
        this.slotRoomData = data
        this.lineEx.active = false
        this.winEx.active = false
        this.pointEx.active = false
        this.normalNodeEx.active = false
        this.initLineColor()
        this.slotRoomData.inCycleLine = false
    }
    initLineColor() {
        for (let i = 0; i < SlotData.defaultRewardLineList.length; i++) {
            let colorCount = this.lineHolder.lines.length
            let colorNo = i % colorCount
            this.slotRoomData.defaultLineColorList[i] = this.lineHolder.getLineByIndex(colorNo)
        }
    }

    intSingleLine(lineIndex: ILineData, parent, fromRight) {
        let lineP = SlotData.instantiateNode(this.normalNodeEx, parent, "lineSingle")
        let linePointList = new Array()
        for (let j = 0; j < lineIndex.line.length; j++) {
            let o1: SlotGrid = this.slotRoomData.slotEx[j].columnList[lineIndex.line[j]]
            let vec1 = this.gridPoint(o1)
            if (j == 0) {
                let v = new cc.Vec2(vec1[GridPoint.LeftCenter].x - SlotData.leftEdgeOffset, vec1[GridPoint.LeftCenter].y)
                linePointList.push(v)
            }
            linePointList.push(vec1[GridPoint.Center])
            if (j == lineIndex.line.length - 1) {
                let v = new cc.Vec2(vec1[GridPoint.RightCenter].x + SlotData.rightEdgeOffset, vec1[GridPoint.RightCenter].y)
                linePointList.push(v)
            }
        }
        this.generateLineByMultiplePoint(linePointList, lineP, lineIndex.color, LineType.Single, fromRight)
        let light = SlotData.instantiateNode(lineP, this.singleLineLightParent, "Light")
        var ligthSprites: cc.Sprite[] = light.getComponentsInChildren<cc.Sprite>(cc.Sprite)
        for (let i = 0; i < ligthSprites.length; i++) {
            // if (ligthSprites[i].node.name == "0") {
            //     this.spriteHoder.node.height = 9
            //     this.spriteHoder.setSprite(ligthSprites[i],"splash")
            // }
            ligthSprites[i].node.color = lineIndex.color.lightColor
        }
        this.slotRoomData.lightLineList[lineIndex.no] = light
        light.opacity = 0
        this.generateShadow(lineP, lineP, 120, 2)
        return lineP
    }
    generateRewardLine(paylines: SlotGame.SlotResult.IPayline[]) {
        let rewardList: ILineData[] = this.resultToPosList(this.slotResultToData(paylines))
        let lightArray = new Array()
        for (let i = 0; i < rewardList.length; i++) {
            let index = rewardList[i].no
            if (!this.slotRoomData.baseLineList[index]) {
                this.slotRoomData.baseLineList[index] = this.intSingleLine(rewardList[i], this.baseLineParent, false)
            }
            this.slotRoomData.baseLineList[index].opacity = 255
            this.slotRoomData.baseLineList[index].active = true
            this.slotRoomData.lightLineList[index].opacity = 255
            this.slotRoomData.lightLineList[index].active = true
            lightArray.push(this.slotRoomData.lightLineList[index])
        }
        return lightArray
    }
    showAllRewardLine(paylines: SlotGame.SlotResult.IPayline[], startCallback?, finishCallback?) {
        let self = this
        this.baseLineParent.active = true
        this.baseLineParent.opacity = 0
        this.singleLineLightParent.active = true
        this.singleLineLightParent.opacity = 0
        for (let i = 0; i < this.slotRoomData.baseLineList.length; i++) {
            if (this.slotRoomData.baseLineList[i]) {
                this.slotRoomData.baseLineList[i].active = false
                this.slotRoomData.baseLineList[i].opacity = 0
            }
        }
        for (let i = 0; i < this.slotRoomData.lightLineList.length; i++) {
            if (this.slotRoomData.lightLineList[i]) {
                this.slotRoomData.lightLineList[i].active = false
                this.slotRoomData.lightLineList[i].opacity = 0
            }
        }
        let lightArray = this.generateRewardLine(paylines)
        self.baseLineParent.runAction(cc.sequence([cc.fadeIn(0.4), cc.callFunc(function () {
            SlotTableSound.playRewardLineSound()
            if (startCallback) {
                startCallback()
            }
            // self.singleLineLightParent.runAction(cc.sequence([cc.fadeIn(0.4), cc.callFunc(() => {
                // self.scheduleOnce(() => {
                //     self.singleLineLightParent.runAction(cc.fadeOut(0.4))
                //     if (startCallback) {
                //         startCallback()
                //     }
                // }, 0.2)
                
            // })]))
            self.scheduleOnce(function () {
                // self.singleLineLightParent.runAction(cc.fadeOut(0.4))
                self.baseLineParent.runAction(cc.sequence([cc.fadeOut(0.5), cc.callFunc(function () {
                    if (finishCallback) {
                        finishCallback()
                    }
                }.bind(self))]))
            }, 1.5)
        }.bind(self))]))
    }
    showBoxLine(paylines: SlotGame.SlotResult.IPayline[]) {
        if (this.slotRoomData.inCycleLine) {
            return
        }
        let self = this
        this.boxLineParent.active = true
        let boxList = []
        let count = 0
        let func = function () {
            let node = boxList[count]
            if (node) {
                node.opacity = 0
                node.runAction(cc.sequence([cc.fadeIn(0.2), cc.callFunc(function () {
                    self.scheduleOnce(function () {
                        node.runAction(cc.fadeOut(0.2))
                    }, 1.2)
                }.bind(this))]))
                if (count >= paylines.length - 1) {
                    count = 0
                } else {
                    count += 1
                }
            } else {
                boxList[count] = self.initBoxLine(paylines[count])
                boxList[count].opacity = 0
                func()
            }
        }
        func()
        this.schedule(func, 2, cc.macro.REPEAT_FOREVER)
        this.slotRoomData.inCycleLine = true
    }
    generateShadow(line, parent, opacity, width) {
        let shadow = SlotData.instantiateNode(line, parent, "Shadow")

        var shadowSprites: cc.Sprite[] = shadow.getComponentsInChildren<cc.Sprite>(cc.Sprite)
        for (let i = 0; i < shadowSprites.length; i++) {
            let node = shadowSprites[i].node
            node.color = cc.Color.BLACK
            node.opacity = opacity
        }
        shadow.setSiblingIndex(0)
        shadow.y -= width
    }
    initSingleLineList(lineIndex: ILineData[], parent): cc.Node[] {
        let lineList: cc.Node[] = []
        for (let i = 0; i < lineIndex.length; i++) {
            lineList[i] = this.intSingleLine(lineIndex[i], parent, false)
        }
        return lineList
    }
    initBoxLine(payline: SlotGame.SlotResult.IPayline) {
        let color: SlotLine = this.slotRoomData.defaultLineColorList[payline.paylineNo - 1]
        let lineP = SlotData.instantiateNode(this.normalNodeEx, this.boxLineParent, "lineBox")

        let lineObjs = new Array()
        for (let i = 0; i < payline.payline.length; i++) {
            let isBox = payline.fromRight ? Math.abs(i - payline.payline.length) <= payline.comboCount : i < payline.comboCount
            if (isBox) {
                this.generateBox(this.slotRoomData.slotEx[i].columnList[payline.payline[i]], lineP, color)
            }
        }
        for (let i = 0; i < payline.payline.length; i++) {
            let o1: SlotGrid = this.slotRoomData.slotEx[i].columnList[payline.payline[i]]
            let vec1 = this.gridPoint(o1)
            let isBox = payline.fromRight ? Math.abs(i - payline.payline.length) <= payline.comboCount : i < payline.comboCount
            if (i == 0) {
                let t = (payline.fromRight && payline.comboCount < payline.payline.length) ? LineType.Single : LineType.SingleBox
                let v = new cc.Vec2(vec1[GridPoint.LeftCenter].x - SlotData.leftEdgeOffset, vec1[GridPoint.LeftCenter].y)
                lineObjs.push(this.generateLineByTwoPoint(v, vec1[GridPoint.LeftCenter], lineP, color, t))
            }
            if (isBox) {
                if (i < payline.payline.length - 1) {
                    let o2: SlotGrid = this.slotRoomData.slotEx[i + 1].columnList[payline.payline[i + 1]]
                    let vec2: cc.Vec2[] = this.gridPoint(o2)
                    let o2IsBox = payline.fromRight ? Math.abs(i + 1 - payline.payline.length) <= payline.comboCount : (i + 1) < payline.comboCount
                    if (o2IsBox) {
                        if (o2.grid.y > o1.grid.y) {
                            lineObjs.push(this.generateLineByTwoPoint(vec1[GridPoint.RightTop], vec2[GridPoint.LeftBottom], lineP, color, LineType.BoxSingleBox))
                        } else if (o2.grid.y < o1.grid.y) {
                            lineObjs.push(this.generateLineByTwoPoint(vec1[GridPoint.RightBottom], vec2[GridPoint.LeftTop], lineP, color, LineType.BoxSingleBox))
                        } else {
                            lineObjs.push(this.generateLineByTwoPoint(vec1[GridPoint.RightCenter], vec2[GridPoint.LeftCenter], lineP, color, LineType.BoxSingleBox))
                        }
                    } else {
                        if (o2.grid.y > o1.grid.y) {
                            lineObjs.push(this.generateLineByTwoPoint(vec1[GridPoint.RightTop], vec2[GridPoint.Center], lineP, color, LineType.BoxSingleSingle))
                        } else if (o2.grid.y < o1.grid.y) {
                            lineObjs.push(this.generateLineByTwoPoint(vec1[GridPoint.RightBottom], vec2[GridPoint.Center], lineP, color, LineType.BoxSingleSingle))
                        } else {
                            lineObjs.push(this.generateLineByTwoPoint(vec1[GridPoint.RightCenter], vec2[GridPoint.Center], lineP, color, LineType.BoxSingleSingle))
                        }
                    }
                }
            } else {
                if (i == 0) {
                    lineObjs.push(this.generateLineByTwoPoint(vec1[GridPoint.LeftCenter], vec1[GridPoint.Center], lineP, color, LineType.Single))
                }
                if (i < payline.payline.length - 1) {
                    let o2: SlotGrid = this.slotRoomData.slotEx[i + 1].columnList[payline.payline[i + 1]]
                    let vec2: cc.Vec2[] = this.gridPoint(o2)
                    let o2IsBox = payline.fromRight ? Math.abs(i + 1 - payline.payline.length) <= payline.comboCount : (i + 1) < payline.comboCount
                    if (o2IsBox) {
                        if (o2.grid.y > o1.grid.y) {
                            lineObjs.push(this.generateLineByTwoPoint(vec1[GridPoint.Center], vec2[GridPoint.LeftBottom], lineP, color, LineType.SingleSingleBox))
                        } else if (o2.grid.y < o1.grid.y) {
                            lineObjs.push(this.generateLineByTwoPoint(vec1[GridPoint.Center], vec2[GridPoint.LeftTop], lineP, color, LineType.SingleSingleBox))
                        } else {
                            lineObjs.push(this.generateLineByTwoPoint(vec1[GridPoint.Center], vec2[GridPoint.LeftCenter], lineP, color, LineType.SingleSingleBox))
                        }
                    } else {
                        lineObjs.push(this.generateLineByTwoPoint(vec1[GridPoint.Center], vec2[GridPoint.Center], lineP, color, LineType.Single))
                    }
                }
                if (i == payline.payline.length - 1) {
                    lineObjs.push(this.generateLineByTwoPoint(vec1[GridPoint.Center], vec1[GridPoint.RightCenter], lineP, color, LineType.Single))
                }
            }
            if (i == payline.payline.length - 1) {
                let t = (payline.fromRight || payline.comboCount == payline.payline.length) ? LineType.BoxSingle : LineType.Single
                let v = new cc.Vec2(vec1[GridPoint.RightCenter].x + SlotData.rightEdgeOffset - 3, vec1[GridPoint.RightCenter].y)
                lineObjs.push(this.generateLineByTwoPoint(vec1[GridPoint.RightCenter], v, lineP, color, t))
            }
        }

        let reCaculateObjs = new Array()
        let frontLine = false
        if (payline.fromRight) {
            for (let i = lineObjs.length - 1; i >= 0; i--) {
                if (lineObjs[i].name == LineType.Single) {
                    if (!frontLine) {
                        reCaculateObjs.push(lineObjs[i + 1])
                        frontLine = true
                    }
                    reCaculateObjs.push(lineObjs[i])
                }
            }
        } else {
            for (let i = 0; i < lineObjs.length; i++) {
                if (lineObjs[i].name == LineType.Single) {
                    if (!frontLine) {
                        reCaculateObjs.push(lineObjs[i - 1])
                        frontLine = true
                    }
                    reCaculateObjs.push(lineObjs[i])
                }
            }
        }
        this.caculationLinePosition(reCaculateObjs, color, payline.fromRight)
        this.boxLineHead(payline, color, lineP, reCaculateObjs[reCaculateObjs.length - 1])
        this.generateShadow(lineP, lineP, 20, 6)
        return lineP
    }
    boxLineHead(payline: SlotGame.SlotResult.IPayline, color: SlotLine, lineP, lastLine: cc.Node) {
        let point = SlotData.instantiateNode(this.pointEx, lineP, "point")
        point.getComponent(cc.Sprite).sizeMode = cc.Sprite.SizeMode.TRIMMED
        point.getComponent(cc.Sprite).spriteFrame = color.point

        let win = SlotData.instantiateNode(this.winEx, lineP, "win")
        // win.getComponent(cc.Sprite).sizeMode = cc.Sprite.SizeMode.TRIMMED

        win.getComponent(cc.Sprite).spriteFrame = color.win
        let winText: cc.Label = win.getChildByName("num").getComponent(cc.Label)
        winText.string = "$" + GameUtil.currencyFormatting(payline.winAmount, 2, true)
        //@ts-ignore
        winText._forceUpdateRenderData(true)
        win.width = winText.node.width > 50 ? winText.node.width + 20 : 70

        let leftGrid = this.slotRoomData.slotEx[0].columnList[payline.payline[0]]
        let rightGrid = this.slotRoomData.slotEx[this.slotRoomData.slotEx.length - 1].columnList[payline.payline[payline.payline.length - 1]]
        if (!payline.fromRight) {
            win.anchorX = 1
            winText.node.x = - win.width / 2
            win.x = leftGrid.grid.x - 120  //(SlotData.gridWidth / 2) - win.width / 2 -
            win.y = leftGrid.grid.y
            point.x = rightGrid.grid.x + (SlotData.gridWidth / 2) + point.width / 4 + SlotData.rightEdgeOffset
            if (lastLine != undefined) {
                point.y = lastLine.y
            } else {
                point.y = rightGrid.grid.y
            }
        } else {
            win.anchorX = 0
            winText.node.x = win.width / 2
            point.x = leftGrid.grid.x - (SlotData.gridWidth / 2) - point.width / 4 - SlotData.leftEdgeOffset
            if (lastLine != undefined) {
                point.y = lastLine.y
            } else {
                point.y = rightGrid.grid.y
            }
            win.x = rightGrid.grid.x + 120  //(SlotData.gridWidth / 2) + win.width / 2 +
            win.y = rightGrid.grid.y
        }
    }
    initBoxLineList(paylines: SlotGame.SlotResult.IPayline[]) {
        let lineList: cc.Node[] = []
        for (let i = 0; i < paylines.length; i++) {
            lineList[i] = this.initBoxLine(paylines[i])
        }
        return lineList
    }
    generateBoxLine(node, parent, color: SlotLine) {
        let pointList: cc.Vec2[] = this.gridPoint(node)
        for (let i = 0; i <= GridPoint.LeftBottom; i++) {
            if (i == GridPoint.LeftBottom) {
                this.generateLine(pointList[i], pointList[0], parent, color, LineType.Box)
            } else {
                this.generateLine(pointList[i], pointList[i + 1], parent, color, LineType.Box)
            }
        }
    }
    generateBox(node: SlotGrid, parent, color: SlotLine) {
        let box = cc.instantiate(this.lineEx);
        box.name = "box"
        box.parent = parent;
        box.active = true;
        let sprite: cc.Sprite = box.getComponent(cc.Sprite)
        sprite.spriteFrame = color.box
        box.width = 202
        box.height = 204
        box.angle = 0
        box.position = node.grid.position

    }

    gridPoint(node: SlotGrid): cc.Vec2[] {
        let pointList: cc.Vec2[] = [new cc.Vec2(node.grid.x - (SlotData.gridWidth / 2), node.grid.y + (SlotData.gridHeight / 2)),
        new cc.Vec2(node.grid.x + (SlotData.gridWidth / 2), node.grid.y + (SlotData.gridHeight / 2)),
        new cc.Vec2(node.grid.x + (SlotData.gridWidth / 2), node.grid.y - (SlotData.gridHeight / 2)),
        new cc.Vec2(node.grid.x - (SlotData.gridWidth / 2), node.grid.y - (SlotData.gridHeight / 2)),
        new cc.Vec2(node.grid.x, node.grid.y + (SlotData.gridHeight / 2)),
        new cc.Vec2(node.grid.x + (SlotData.gridWidth / 2), node.grid.y),
        new cc.Vec2(node.grid.x, node.grid.y - (SlotData.gridHeight / 2)),
        new cc.Vec2(node.grid.x - (SlotData.gridWidth / 2), node.grid.y),
        new cc.Vec2(node.grid.x, node.grid.y)
        ]
        return pointList
    }
    resultToPosList(result) {
        let list: ILineData[] = []
        for (let i = 0; i < result.length; i++) {
            list[i] = {
                line: [],
                color: result[i].color,
                no: result[i].no
            }
            for (let j = 0; j < result[i].line.length; j++) {
                list[i].line[j] = result[i].line[j].gridPos
            }
        }
        return list
    }
    slotResultToData(payLines): ILineResult[] {
        let result: ILineResult[] = []
        for (let i = 0; i < payLines.length; i++) {
            result[i] = this.payLineToData(payLines[i])
        }
        return result
    }
    payLineToData(payLine: SlotGame.SlotResult.IPayline) {
        let line = this.lineToRewardData(payLine)
        let result: ILineResult = {
            win: payLine.winAmount,
            starting: payLine.fromRight ? 1 : 0,
            no: payLine.paylineNo - 1,
            line: line,
            color: this.slotRoomData.defaultLineColorList[payLine.paylineNo - 1]
        }
        return result
    }

    lineToRewardData(payLine): ILineBox[] {
        let data: ILineBox[] = []
        for (let i = 0; i < payLine.payline.length; i++) {
            let box = payLine.fromRight ? Math.abs(i - payLine.payline.length) <= payLine.comboCount : i < payLine.comboCount
            data[i] = {
                gridPos: payLine.payline[i],
                box: box
            }
        }
        return data
    }
    // cycleLine(lineList) {
    //     if (this.slotRoomData.inCycleLine) {
    //         return
    //     }
    //     let self = this
    //     for (let i = 0; i < lineList.length; i++) {
    //         lineList[i].active = true
    //         lineList[i].opacity = 0
    //     }
    //     let count = 0
    //     let func = function () {
    //         let node = lineList[count]
    //         if (node) {
    //             node.runAction(cc.sequence([cc.fadeIn(0.3), cc.callFunc(function () {
    //                 self.scheduleOnce(function () {
    //                     node.runAction(cc.fadeOut(0.3))
    //                 }, 1.3)
    //             }.bind(this))]))
    //             if (count == lineList.length - 1) {
    //                 count = 0
    //             } else {
    //                 count += 1
    //             }
    //         }
    //     }
    //     func()
    //     this.schedule(func, 2, cc.macro.REPEAT_FOREVER)
    //     this.slotRoomData.inCycleLine = true
    // }
    lineToLineData(line: number[], index: number): ILineData {
        let a: ILineData = {
            color: this.slotRoomData.defaultLineColorList[index],
            line: line,
            no: index
        }
        return a
    }
    lineListToIndexList(lines: number[][]): ILineData[] {
        let a: ILineData[] = []
        for (let i = 0; i < lines.length; i++) {
            a[i] = this.lineToLineData(lines[i], i)
        }
        return a
    }
    cycleBaseLine() {
        if (this.slotRoomData.inCycleLine) {
            return
        }
        this.baseLineParent.active = true
        let line: ILineData[] = this.lineListToIndexList(SlotData.defaultRewardLineList)
        for (let i = 0; i < this.slotRoomData.baseLineList.length; i++) {
            if (this.slotRoomData.baseLineList[i]) {
                this.slotRoomData.baseLineList[i].active = true
                this.slotRoomData.baseLineList[i].opacity = 0
            }
        }
        this.baseLineParent.opacity = 255
        let self = this
        let count = parseInt(LoaclStorage.getString("SlotDefaultRewardLineIndex", "0"))
        if (count >= line.length - 1) {
            count = 0
            LoaclStorage.setString("SlotDefaultRewardLineIndex", count + "")
        }
        let func = function () {
            if (count >= line.length - 1) {
                count = 0
                LoaclStorage.setString("SlotDefaultRewardLineIndex", count + "")
            }
            let node = self.slotRoomData.baseLineList[count]
            if (node) {
                node.active = true
                node.opacity = 0
                node.runAction(cc.sequence([cc.fadeIn(0.2), cc.callFunc(function () {
                    self.scheduleOnce(function () {
                        node.runAction(cc.fadeOut(0.2))
                    }, 1.2)
                }.bind(this))]))
                if (count >= line.length - 1) {
                    count = 0
                } else {
                    count += 1
                }
                LoaclStorage.setString("SlotDefaultRewardLineIndex", count + "")
            } else {
                self.slotRoomData.baseLineList[count] = self.intSingleLine(line[count], self.baseLineParent, false)
                self.slotRoomData.baseLineList[count].opacity = 0
                func()
            }
        }
        func()
        this.schedule(func, 1.7, cc.macro.REPEAT_FOREVER)
        this.slotRoomData.inCycleLine = true
    }

    generateLineByMultiplePoint(pointList, parent, color, lineType, fromRight) {
        let len = pointList.length
        let angleList = []
        for (let i = 0; i < len; i++) {
            let p = pointList[i]
            if (i < len - 1) {
                let p1 = pointList[i + 1]
                let angle = this.getAngle(p, p1);
                if (p1.y > p.y) {
                    angle = 180 - angle
                }
                angleList[i] = angle
            }
        }
        let notUsePoint = []
        let usePoint = []
        for (let i = 0; i < angleList.length; i++) {
            if (i < angleList.length - 1 && angleList[i] == angleList[i + 1]) {
                notUsePoint.push(i + 1)
            }
        }
        for (let i = 0; i < len; i++) {
            if (notUsePoint.indexOf(i) < 0) {
                usePoint.push(pointList[i])
            }
        }
        let lineObjs = []
        for (let i = 0; i < usePoint.length; i++) {
            if (i < usePoint.length - 1) {
                let obj = this.generateLineByTwoPoint(usePoint[i], usePoint[i + 1], parent, color, lineType)
                lineObjs.push(obj)
            }
        }
        this.caculationLinePosition(fromRight ? lineObjs.reverse() : lineObjs, color, fromRight)
    }

    caculationLinePosition(lineObjs, color: SlotLine, fromRight) {
        for (let i = 1; i < lineObjs.length; i++) {
            let fl: cc.Node = lineObjs[i - 1]
            let cl: cc.Node = lineObjs[i]
            let hd1 = Math.PI / 180 * Math.abs(fl.angle)
            let hd2 = Math.PI / 180 * Math.abs(cl.angle)
            let pointX = cl.x + cl.width * Math.cos(hd2) / 2
            let pointY = cl.y + (cl.angle > 0 ? 1 : -1) * cl.width * Math.sin(hd2) / 2
            if (!fromRight) {
                let flAnchorX = fl.scaleX > 0 ? fl.anchorX : 1 - fl.anchorX
                if (fl.angle == 0) {
                    if (cl.angle > 0) {
                        cl.anchorX = 0
                        cl.anchorY = 1
                    } else if (cl.angle < 0) {
                        cl.anchorX = 0
                        cl.anchorY = 0
                    }
                    cl.x = fl.x + fl.width * (1 - flAnchorX) * Math.abs(fl.scaleX) + cl.width * cl.anchorX
                    cl.y = fl.y + fl.height * (cl.anchorY - fl.anchorY) * Math.abs(fl.scaleY)

                } else if (fl.angle > 0) {
                    cl.anchorX = 0
                    cl.anchorY = 0
                    cl.x = fl.x + fl.width * Math.abs(fl.scaleX) * (1 - flAnchorX) * Math.cos(hd1) - (cl.anchorY - fl.anchorY) * fl.height * Math.abs(fl.scaleY) * Math.sin(hd1)
                    cl.y = fl.y + fl.width * Math.abs(fl.scaleX) * (1 - flAnchorX) * Math.sin(hd1) + (cl.anchorY - fl.anchorY) * fl.height * Math.abs(fl.scaleY) * Math.cos(hd1)
                } else if (fl.angle < 0) {
                    cl.anchorX = 0
                    cl.anchorY = 1
                    cl.x = fl.x + fl.width * Math.abs(fl.scaleX) * (1 - flAnchorX) * Math.cos(hd1) + (cl.anchorY - fl.anchorY) * fl.height * Math.abs(fl.scaleY) * Math.sin(hd1)
                    cl.y = fl.y - fl.width * Math.abs(fl.scaleX) * (1 - flAnchorX) * Math.sin(hd1) + (cl.anchorY - fl.anchorY) * fl.height * Math.abs(fl.scaleY) * Math.cos(hd1)
                }

                if (cl.angle < 0) {
                    let o
                    if (Math.abs(pointY + 10) < 1) {
                        o = -10 + (cl.height / 2)
                    } else if (Math.abs(pointY - 200) < 1) {
                        o = 200 + (cl.height / 2)
                    } else if (Math.abs(pointY + 220) < 1) {
                        o = -220 + (cl.height / 2)
                    }
                    if (o != undefined) {
                        let h = cl.y - o
                        let w = Math.sqrt(h * h * (1 + (1 / Math.tan(hd2)) * (1 / Math.tan(hd2)))) + cl.height / Math.tan(hd2)
                        cl.width = w
                    }
                } else if (cl.angle > 0) {
                    let o
                    if (Math.abs(pointY + 10) < 1) {
                        o = -10 - (cl.height / 2)
                    } else if (Math.abs(pointY - 200) < 1) {
                        o = 200 - (cl.height / 2)
                    } else if (Math.abs(pointY + 220) < 1) {
                        o = -220 - (cl.height / 2)
                    }
                    if (o != undefined) {
                        let h = o - cl.y
                        let w = Math.sqrt(h * h * (1 + (1 / Math.tan(hd2)) * (1 / Math.tan(hd2)))) + cl.height / Math.tan(hd2)
                        cl.width = w
                    }
                }

                // let x = pointX - cl.x
                // let y = cl.angle > 0 ? pointY - cl.y : cl.y - pointY
                // let w = Math.sqrt(x * x + y * y - (cl.height / 2) * (cl.height / 2))
                // let a1 = Math.atan(y / x)
                // let a2 = Math.atan(cl.height / 2 / w)
                // let angle = a1 * 180 / Math.PI + a2 * 180 / Math.PI
                // cl.angle = cl.angle > 0 ? angle : -angle
                // if(Math.abs(angle) < 10){
                //     cl.angle = 0
                // }
                // cl.width = w


                /*   ************************************************************************************************************
                x轴对齐 
                                // let nextAngle = i < lineObjs.length - 1 ? lineObjs[i + 1].angle : 0
                                // if (nextAngle == 0) {
                                //     if (cl.angle < 0) {
                                //         let o
                                //         if (Math.abs(pointY + 10) < 1) {
                                //             o = -10 + (cl.height / 2)
                                //         } else if (Math.abs(pointY - 200) < 1) {
                                //             o = 200 + (cl.height / 2)
                                //         } else if (Math.abs(pointY + 220) < 1) {
                                //             o = -220 + (cl.height / 2)
                                //         }
                                //         if (o != undefined) {
                                //             let h = cl.y - o
                                //             let w = Math.sqrt(h * h * (1 + (1 / Math.tan(hd2)) * (1 / Math.tan(hd2)))) + cl.height / Math.tan(hd2)
                                //             cl.width = w
                                //         }
                                //     } else if (cl.angle > 0) {
                                //         let o
                                //         if (Math.abs(pointY + 10) < 1) {
                                //             o = -10 - (cl.height / 2)
                                //         } else if (Math.abs(pointY - 200) < 1) {
                                //             o = 200 - (cl.height / 2)
                                //         } else if (Math.abs(pointY + 220) < 1) {
                                //             o = -220 - (cl.height / 2)
                                //         }
                                //         if (o != undefined) {
                                //             let h = o - cl.y
                                //             let w = Math.sqrt(h * h * (1 + (1 / Math.tan(hd2)) * (1 / Math.tan(hd2)))) + cl.height / Math.tan(hd2)
                                //             cl.width = w
                                //         }
                                //     } else {
                                //         // cl.width = pointX - cl.x
                                //     }
                                // } else {
                                //     if (cl.angle > 0) {
                                //         let o
                                //         // if (Math.abs(pointX + 235) < 1) {
                                //         //     o = -235 - cl.x - (cl.height / 2) * Math.sin(hd2)
                                //         // } else if (Math.abs(pointX) < 1) {
                                //         //     o = 0 - cl.x - (cl.height / 2) * Math.sin(hd2)
                                //         // } else if (Math.abs(pointX - 220) < 1) {
                                //         //     o = 235 - cl.x - (cl.height / 2) * Math.sin(hd2)
                                //         // }
                                //         // if (o != undefined) {
                                //         //     let w = (o - cl.height * Math.sin(hd2)) / Math.cos(hd2)
                                //         //     cl.width = w
                                //         // }
                                //         if (Math.abs(pointX + 235) < 1) {
                                //             o = -235 - cl.x
                                //         } else if (Math.abs(pointX) < 1) {
                                //             o = 0 - cl.x
                                //         } else if (Math.abs(pointX - 220) < 1) {
                                //             o = 235 - cl.x
                                //         }
                                //         if (o != undefined) {
                                //             let w = o / Math.cos(hd2) - cl.height / 2 * Math.tan(hd2)
                                //             cl.width = w
                                //         }
                                //     } else if (cl.angle < 0) {
                                //         let o
                                //         // if (Math.abs(pointX + 235) < 1) {
                                //         //     o = -235 - cl.x + (cl.height / 2) * Math.sin(hd2)
                                //         // } else if (Math.abs(pointX) < 1) {
                                //         //     o = 0 - cl.x + (cl.height / 2) * Math.sin(hd2)
                                //         // } else if (Math.abs(pointX - 220) < 1) {
                                //         //     o = 235 - cl.x + (cl.height / 2) * Math.sin(hd2)
                                //         // }
                                //         // if (o != undefined) {
                                //         //     let w = (o - cl.height * Math.cos(hd2)) / Math.cos(hd2)
                                //         //     cl.width = w
                                //         // }
                                //         if (Math.abs(pointX + 235) < 1) {
                                //             o = -235 - cl.x
                                //         } else if (Math.abs(pointX) < 1) {
                                //             o = 0 - cl.x
                                //         } else if (Math.abs(pointX - 220) < 1) {
                                //             o = 235 - cl.x
                                //         }
                                //         if (o != undefined) {
                                //             let w = o / Math.cos(hd2) - cl.height / 2 * Math.tan(hd2)
                                //             cl.width = w
                                //         }
                                //     } else {
                                //         // cl.width = pointX - cl.x
                                //     }
                                // }
                **************************************************************************************************** */
            } else {
                let flAnchorX = fl.scaleX > 0 ? fl.anchorX : 1 - fl.anchorX
                if (fl.angle == 0) {
                    if (cl.angle > 0) {
                        cl.anchorX = 1
                        cl.anchorY = 0
                    } else if (cl.angle < 0) {
                        cl.anchorX = 1
                        cl.anchorY = 1
                    }
                    cl.x = fl.x - fl.width * Math.abs(fl.scaleX) * flAnchorX - cl.width * Math.abs(fl.scaleX) * (1 - cl.anchorX)
                    cl.y = fl.y + fl.height * Math.abs(fl.scaleY) * (cl.anchorY - fl.anchorY)
                } else if (fl.angle > 0) {
                    cl.anchorX = 1
                    cl.anchorY = 1
                    cl.x = fl.x - fl.width * Math.abs(fl.scaleX) * flAnchorX * Math.cos(hd1) - (cl.anchorY - fl.anchorY) * fl.height * Math.abs(fl.scaleY) * Math.sin(hd1)
                    cl.y = fl.y - fl.width * Math.abs(fl.scaleX) * flAnchorX * Math.sin(hd1) + (cl.anchorY - fl.anchorY) * fl.height * Math.abs(fl.scaleY) * Math.cos(hd1)
                } else if (fl.angle < 0) {
                    cl.anchorX = 1
                    cl.anchorY = 0
                    cl.x = fl.x - fl.width * Math.abs(fl.scaleX) * flAnchorX * Math.cos(hd1) + (cl.anchorY - fl.anchorY) * fl.height * Math.abs(fl.scaleY) * Math.sin(hd1)
                    cl.y = fl.y + fl.width * Math.abs(fl.scaleX) * flAnchorX * Math.sin(hd1) + (cl.anchorY - fl.anchorY) * fl.height * Math.abs(fl.scaleY) * Math.cos(hd1)
                }

            }
            if (i == lineObjs.length - 1) {
                if (!fromRight) {
                    let o: SlotGrid = this.slotRoomData.slotEx[this.slotRoomData.slotEx.length - 1].columnList[0]
                    let vec = this.gridPoint(o)
                    let rightX = vec[GridPoint.RightCenter].x + SlotData.rightEdgeOffset
                    if (cl.anchorX == 0) {
                        cl.width = rightX - cl.x
                    } else {
                        let clw = rightX - cl.x
                        cl.x = clw > cl.width / 2 ? cl.x + (clw - cl.width / 2) / 2 : cl.x - (cl.width / 2 - clw) / 2
                        cl.width = cl.width / 2 + clw
                    }
                } else {
                    let o: SlotGrid = this.slotRoomData.slotEx[0].columnList[0]
                    let vec = this.gridPoint(o)
                    let leftX = vec[GridPoint.LeftCenter].x - SlotData.leftEdgeOffset
                    if (cl.anchorX == 0.5) {
                        let clw = cl.x - leftX
                        cl.x = clw > cl.width / 2 ? cl.x - (clw - cl.width / 2) / 2 : cl.x + (cl.width / 2 - clw) / 2
                        cl.width = cl.width / 2 + clw
                    } else {
                        cl.width = cl.x - leftX
                    }
                }
            }
            this.repairCorner(fl, cl, color, fromRight)
        }
    }

    repairCorner(obj1, obj2, color: SlotLine, fromRight) {
        if (obj1.angle == obj2.angle) {
            return
        }
        let hd1 = Math.PI / 180 * Math.abs(obj1.angle)
        let hd2 = Math.PI / 180 * Math.abs(obj2.angle)
        let cornerObj: cc.Node = SlotData.instantiateNode(this.lineEx, obj1.parent)
        cornerObj.setSiblingIndex(0)
        let cornerSprite = cornerObj.getComponent(cc.Sprite)
        cornerSprite.spriteFrame = this.lineHolder.getCornerByName(Math.abs(obj1.angle), Math.abs(obj2.angle), color.lineIndex)
        let angle = [0, 42, 61, 39, 67]
        cornerSprite.sizeMode = cc.Sprite.SizeMode.TRIMMED
        cornerObj.scale = 0.25
        if ((fromRight && ((obj1.angle == 0 && obj2.angle > 0) || (obj1.angle < 0 && obj2.angle == 0) || (obj1.angle < 0 && obj2.angle > 0))) ||
            (!fromRight && ((obj1.angle == 0 && obj2.angle < 0) || (obj1.angle > 0 && obj2.angle == 0) || (obj1.angle > 0 && obj2.angle < 0)))) {
            cornerObj.scaleY = -cornerObj.scale
        }
        if ((fromRight && ((obj1.angle == 0) || (obj1.angle == angle[1] && obj2.angle == -angle[2]) || (obj1.angle == -angle[1] && obj2.angle == angle[2]) ||
            (obj1.angle == angle[4] && obj2.angle == -angle[2]) || (obj1.angle == angle[4] && obj2.angle == -angle[1]) ||
            (obj1.angle == angle[3] && obj2.angle == -angle[2]) || (obj1.angle == angle[3] && obj2.angle == -angle[1]) ||
            (obj1.angle == -angle[4] && obj2.angle == angle[2]) || (obj1.angle == -angle[4] && obj2.angle == angle[1]) ||
            (obj1.angle == -angle[3] && obj2.angle == angle[2]) || (obj1.angle == -angle[3] && obj2.angle == angle[1]))) ||
            (!fromRight && ((obj2.angle == 0) || (obj1.angle == -angle[2] && obj2.angle == angle[1]) || (obj1.angle == angle[2] && obj2.angle == -angle[1])))) {
            cornerObj.scaleX = -cornerObj.scale
        }
        let offset = [0.3]
        let obj1AnchorX = obj1.scaleX > 0 ? obj1.anchorX : 1 - obj1.anchorX
        if (obj1.angle == 0) {
            cornerObj.anchorX = 0
            cornerObj.anchorY = 0

            let anchorY = cornerObj.scaleY > 0 ? cornerObj.anchorY : 1 - cornerObj.anchorY
            cornerObj.x = fromRight ? obj1.x - obj1.width * Math.abs(obj1.scaleX) * obj1AnchorX : obj1.x + obj1.width * Math.abs(obj1.scaleX) * (1 - obj1AnchorX)
            cornerObj.y = obj1.y + (anchorY - obj1.anchorY) * obj1.height * Math.abs(obj1.scaleY)
            if (cornerSprite.spriteFrame == color.corner[1]) {
                cornerObj.x = fromRight ? cornerObj.x + offset[0] : cornerObj.x - offset[0]
            }
        } else if (obj2.angle == 0) {
            cornerObj.anchorX = 1
            cornerObj.anchorY = 0
            let anchorX = cornerObj.scaleX > 0 ? cornerObj.anchorX : 1 - cornerObj.anchorX
            let anchorY = cornerObj.scaleY > 0 ? cornerObj.anchorY : 1 - cornerObj.anchorY
            cornerObj.x = fromRight ?
                obj2.x + obj2.width * (1 - obj2.anchorX) + anchorX * cornerObj.width * Math.abs(cornerObj.scaleX) :
                obj2.x - obj2.width * obj2.anchorX - (1 - anchorX) * cornerObj.width * Math.abs(cornerObj.scaleX)
            cornerObj.y = obj2.y + (anchorY - obj2.anchorY) * obj2.height * Math.abs(obj2.scaleY)
            if (cornerSprite.spriteFrame == color.corner[1]) {
                cornerObj.x = fromRight ? cornerObj.x - offset[0] : cornerObj.x + offset[0]
            }
        } else {
            if (fromRight) {
                cornerObj.x = obj1.x - obj1.width * Math.abs(obj1.scaleX) * Math.cos(hd1) * obj1AnchorX - cornerObj.width * 0.5 * Math.abs(cornerObj.scaleX)
                cornerObj.y = obj1.y + (obj1.angle < 0 ? 1 : -1) * obj1.width * Math.abs(obj1.scaleX) * Math.sin(hd1) * obj1AnchorX
                if (Math.abs(obj1.angle) == Math.abs(obj2.angle) && Math.abs(obj1.angle) == angle[2]) {
                    if (obj1.angle > 0) {
                        cornerObj.x += 1
                        cornerObj.y -= 6.3
                    } else {
                        cornerObj.x += 1
                        cornerObj.y += 6.3
                    }
                } else if (Math.abs(obj1.angle) == Math.abs(obj2.angle) && Math.abs(obj1.angle) == angle[1]) {
                    if (obj1.angle > 0) {
                        cornerObj.x += 1
                        cornerObj.y += 1.2
                    } else {
                        cornerObj.x += 1
                        cornerObj.y -= 1.2
                    }
                } else if (Math.abs(obj1.angle) != Math.abs(obj2.angle)) {
                    if (obj1.angle > 0) {
                        if (Math.abs(obj1.angle) == angle[1]) {
                            cornerObj.x += 1
                        } else if (Math.abs(obj1.angle) == angle[2]) {
                            cornerObj.x += 0.5
                            cornerObj.y -= 3.1
                        } else if (Math.abs(obj1.angle) == angle[3] && obj2.angle == -angle[1]) {
                            cornerObj.x += 4.8
                            cornerObj.y -= 2.7
                        } else if (Math.abs(obj1.angle) == angle[3] && obj2.angle == -angle[2]) {
                            cornerObj.x += 5.2
                            cornerObj.y -= 3.7
                        } else if (Math.abs(obj1.angle) == angle[4] && obj2.angle == -angle[1]) {
                            cornerObj.x += 6.2
                            cornerObj.y -= 7
                        } else if (Math.abs(obj1.angle) == angle[4] && obj2.angle == -angle[2]) {
                            cornerObj.x += 6.4
                            cornerObj.y -= 10.3
                        }
                    } else {
                        if (Math.abs(obj1.angle) == angle[1]) {
                            cornerObj.x += 1
                        } else if (Math.abs(obj1.angle) == angle[2]) {
                            cornerObj.x += 0.5
                            cornerObj.y += 3.1
                        } else if (Math.abs(obj1.angle) == angle[3] && obj2.angle == angle[1]) {
                            cornerObj.x += 4.8
                            cornerObj.y += 2.7
                        } else if (Math.abs(obj1.angle) == angle[3] && obj2.angle == angle[2]) {
                            cornerObj.x += 5.2
                            cornerObj.y += 3.7
                        } else if (Math.abs(obj1.angle) == angle[4] && obj2.angle == angle[1]) {
                            cornerObj.x += 6.2
                            cornerObj.y += 7
                        } else if (Math.abs(obj1.angle) == angle[4] && obj2.angle == angle[2]) {
                            cornerObj.x += 6.4
                            cornerObj.y += 10.3
                        }
                    }
                }
            } else {
                cornerObj.x = obj1.x + obj1.width * Math.abs(obj1.scaleX) * Math.cos(hd1) * (1 - obj1AnchorX) + cornerObj.width * 0.5 * Math.abs(cornerObj.scaleX)
                cornerObj.y = obj1.y + (obj1.angle > 0 ? 1 : -1) * obj1.width * Math.abs(obj1.scaleX) * Math.sin(hd1) * (1 - obj1AnchorX)
                if (Math.abs(obj1.angle) == Math.abs(obj2.angle) && Math.abs(obj1.angle) == angle[2]) {
                    if (obj1.angle > 0) {
                        cornerObj.x -= 1
                        cornerObj.y += 6.3
                    } else {
                        cornerObj.x -= 1
                        cornerObj.y -= 6.3
                    }
                } else if (Math.abs(obj1.angle) == Math.abs(obj2.angle) && Math.abs(obj1.angle) == angle[1]) {
                    if (obj1.angle > 0) {
                        cornerObj.x -= 1
                        cornerObj.y -= 1.2
                    } else {
                        cornerObj.x -= 1
                        cornerObj.y += 1.2
                    }
                } else if (Math.abs(obj1.angle) != Math.abs(obj2.angle)) {
                    if (obj1.angle > 0) {
                        if (Math.abs(obj1.angle) == angle[1]) {
                            cornerObj.x -= 1
                        } else if (Math.abs(obj1.angle) == angle[2]) {
                            cornerObj.x -= 0.5
                            cornerObj.y += 3.1
                        } else if (Math.abs(obj1.angle) == angle[3] && obj2.angle == -angle[1]) {
                            cornerObj.x -= 4.8
                            cornerObj.y += 2.7
                        } else if (Math.abs(obj1.angle) == angle[3] && obj2.angle == -angle[2]) {
                            cornerObj.x -= 5.2
                            cornerObj.y += 3.7
                        } else if (Math.abs(obj1.angle) == angle[4] && obj2.angle == -angle[1]) {
                            cornerObj.x -= 6.2
                            cornerObj.y += 7
                        } else if (Math.abs(obj1.angle) == angle[4] && obj2.angle == -angle[2]) {
                            cornerObj.x -= 6.4
                            cornerObj.y += 10.3
                        }
                    } else {
                        if (Math.abs(obj1.angle) == angle[1]) {
                            cornerObj.x -= 1
                        } else if (Math.abs(obj1.angle) == angle[2]) {
                            cornerObj.x -= 0.5
                            cornerObj.y -= 3.1
                        } else if (Math.abs(obj1.angle) == angle[3] && obj2.angle == angle[1]) {
                            cornerObj.x -= 4.8
                            cornerObj.y -= 2.7
                        } else if (Math.abs(obj1.angle) == angle[3] && obj2.angle == angle[2]) {
                            cornerObj.x -= 5.2
                            cornerObj.y -= 3.7
                        } else if (Math.abs(obj1.angle) == angle[4] && obj2.angle == angle[1]) {
                            cornerObj.x -= 6.2
                            cornerObj.y -= 7
                        } else if (Math.abs(obj1.angle) == angle[4] && obj2.angle == angle[2]) {
                            cornerObj.x -= 6.4
                            cornerObj.y -= 10.3
                        }
                    }
                }
            }
        }
    }

    generateLine(point1, point2, parent, color: SlotLine, lineType: LineType) {
        this.generateLineByTwoPoint(point1, point2, parent, color, lineType)
    }

    generateLineByTwoPoint(point1, point2, parent, color: SlotLine, lineType: LineType) {
        let w = Math.abs(point2.x - point1.x)
        let h = Math.abs(point2.y - point1.y)
        let l = Math.sqrt(w * w + h * h)
        let angle = this.getAngle(point1, point2);
        if (point2.y > point1.y) {
            angle = 180 - angle
        }

        let line = cc.instantiate(this.lineEx);
        let sprite = line.getComponent(cc.Sprite)
        sprite.spriteFrame = color.line
        line.parent = parent;
        line.active = true;
        line.width = l
        line.height = SlotData.lineHeight
        angle = -angle
        if (angle < -90) {
            angle += 180
        }
        line.angle = angle
        line.x = (point1.x < point2.x ? point1.x : point2.x) + w / 2
        line.y = (point1.y < point2.y ? point1.y : point2.y) + h / 2
        line.name = lineType.toString()
        if (lineType == LineType.Single) {
            return line
        }
        sprite.spriteFrame = color.lineSp1
        sprite.sizeMode = cc.Sprite.SizeMode.TRIMMED
        sprite.sizeMode = cc.Sprite.SizeMode.CUSTOM
        sprite.type = cc.Sprite.Type.SLICED
        line.scale = 0.25
        if (lineType == LineType.BoxSingleBox) {
            sprite.spriteFrame = color.lineSp2
            if (angle == 0) {
                line.width = 170
            } else if (Math.abs(angle) < 45) {
                line.width = 200
                if (line.angle > 0) {
                    line.angle -= 3
                } else if (line.angle < 0) {
                    line.angle += 3
                }
            } else {
                line.width = 924
                if (line.angle > 0) {
                    line.angle -= 0.5
                } else if (line.angle < 0) {
                    line.angle += 0.5
                }
            }
        } else if (lineType == LineType.SingleBox) {
            line.x = (point1.x < point2.x ? point2.x : point1.x) - 3
            line.anchorX = 1
            line.width = 90
        } else if (lineType == LineType.BoxSingle) {
            line.scaleX = -line.scale
            line.x = (point1.x < point2.x ? point1.x : point2.x) + 3
            line.anchorX = 1
            line.width = 90
        } else if (lineType == LineType.BoxSingleSingle) {
            line.scaleX = -line.scale
            line.width = l * 4
            if (line.angle == 0) {
                line.x = (point1.x < point2.x ? point1.x : point2.x) + 3
                line.anchorX = 1
            } else if (line.angle < -45) {
                line.x += 0.1
                line.y -= 3
            } else if (line.angle > 45) {
                line.x += 0.1
                line.y += 2.7
            } else if (line.angle < 0 && line.angle > -45) {
                line.x += 1.5
                line.y -= 1
            } else if (line.angle > 0 && line.angle < 45) {
                line.x += 1
                line.y += 0.5
            }
        } else if (lineType == LineType.SingleSingleBox) {
            line.width = l * 4
            if (line.angle == 0) {
                line.x = (point1.x < point2.x ? point2.x : point1.x) - 3
                line.anchorX = 1
            } else if (line.angle < -45) {
                line.x -= 0.1
                line.y += 3
            } else if (line.angle > 45) {
                line.x -= 0.1
                line.y -= 2.7
            } else if (line.angle < 0 && line.angle > -45) {
                line.x -= 1.5
                line.y += 1
            } else if (line.angle > 0 && line.angle < 45) {
                line.x -= 1
                line.y -= 0.5
            }
        }
        return line
    }

    getAngle = function (A, B) {
        var x1 = A.x;
        var y1 = A.y;
        var x2 = B.x;
        var y2 = B.y;
        var a = Math.abs(x1 - x2);
        var b = Math.abs(y1 - y2);
        if (a == 0) {
            return 90
        }
        if (b == 0) {
            return 0
        }
        var c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
        var randianToAngle = function (scale) {
            var radian = Math.acos(scale);
            var angle = 180 / Math.PI * radian;
            return Math.round(angle);
        }
        var angleB = randianToAngle(a / c);
        return angleB
    }

    endCycleLine() {
        this.unscheduleAllCallbacks()
        this.baseLineParent.stopAllActions()
        this.baseLineParent.active = false
        this.singleLineLightParent.stopAllActions()
        this.singleLineLightParent.active = false
        this.boxLineParent.destroyAllChildren()
        this.slotRoomData.inCycleLine = false

    }
    testLine() {
        this.endCycleLine()

        let str = this.testEditor.string
        let strs = str.split(",")
        let l = []
        for (let i = 0; i < 5; i++) {
            l[i] = parseInt(strs[i])
        }
        this.baseLineParent.active = true
        let line = this.lineListToIndexList([l])
        this.intSingleLine(line[0], this.singleLineParent, strs[5] == "0")
    }

    testKuang() {
        this.endCycleLine()
        let str = this.testEditor.string
        let strs = str.split(",")
        let l = []
        for (let i = 0; i < 5; i++) {
            l[i] = parseInt(strs[i])
        }
        let payline: SlotGame.SlotResult.IPayline = {
            symbol: "777",
            comboCount: parseInt(strs[5]),
            fromRight: strs[6] == "0" ? true : false,
            paylineNo: 1,
            winAmount: strs[7] != undefined ? parseInt(strs[7]) : 100,
            payline: l,
        }
        this.initBoxLine(payline)
    }

    testHuifu() {
        this.singleLineParent.destroyAllChildren()
        this.boxLineParent.destroyAllChildren()
        this.cycleBaseLine()
    }
    on_destroy() {
        this.unscheduleAllCallbacks()
    }
}